<template>
  <div class="search-box" style="padding-top:0;">
    <el-form ref="form" size="mini"  :inline="true" :model="ruleForm" :rules="rules" class="demo-form-inline">
      <el-form-item label="用户名或昵称：" prop="userName">
        <el-input v-model="ruleForm.userName" clearable style="max-width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="客户名称：" prop="userName">
        <el-input v-model="ruleForm.departName" clearable style="max-width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="ruleForm.status" clearable placeholder style="max-width:180px;">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="submit" v-permission="'1003'">查询</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-delete" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import organizationalSelect from '../comm/organizationalSelect';

export default {
  name: 'search',
  components: { organizationalSelect },
  props: {
    roleData: {
      Array,
      default: []
    }
  },
  computed: {
    options() {
      return this.$utils.transforTree(this.treeData);
    }
  },
  data() {
    return {
      ruleForm: {
        userName: '',
        departName: '',
        status: ''
      },
      rules: {},
      selectedOptions: [],
      statusOptions: [
        {
          label: '启用',
          value: '1'
        },
        {
          label: '禁用',
          value: '2'
        }
      ],
      selectedArr: []
    };
  },
  methods: {
    handleChange(arry) {
      this.ruleForm.depCode = arry.length ? arry[arry.length - 1] : '';
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('getUserList', this.ruleForm);// emit
        }
        else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        userName: '',
        roleId: '',
        status: ''
      };
      this.$emit('getUserList', this.ruleForm);// emit
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
